import React from 'react';
import { useConfig } from '../../providers/Config';

interface FeatureFlagProps {
  requiredFeatureFlags: string;
  children: React.ReactNode;
}

const checkFeatureFlag = (featureFlags: { [key: string]: boolean }, requiredFeatureFlags: string) => {
  if (!requiredFeatureFlags || featureFlags[requiredFeatureFlags]) return true;
  return false;
};

export const FeatureFlag: React.FC<FeatureFlagProps> = ({ requiredFeatureFlags, children }) => {
  const { featureFlags } = useConfig();

  return checkFeatureFlag(featureFlags, requiredFeatureFlags) ? <>{children}</> : null;
};
